(function () {
    'use strict';

    angular.module('collaterate.common', []);
}());
